import React from 'react';
import { COLORS } from '../constants';

const Button = ({ children, variant = "primary", onClick, className = "", disabled = false, type = "button" }) => {
  const baseStyle = "cursor-pointer px-10 py-4 rounded-full text-lg font-extrabold transition-all duration-300 transform hover:scale-110 active:scale-95 shadow-[0_10px_20px_rgba(0,0,0,0.2)] flex items-center justify-center gap-3 tracking-wide uppercase";

  const variantStyles = {
    primary: {
      backgroundColor: COLORS.accent,
      color: COLORS.secondaryBg,
      border: `2px solid ${COLORS.accent}`
    },
    secondary: {
      backgroundColor: COLORS.secondaryBg,
      color: COLORS.lightSurface,
      border: `2px solid ${COLORS.secondaryBg}`
    },
    outline: {
      backgroundColor: 'transparent',
      border: `2.5px solid currentColor`,
      color: 'inherit'
    }
  };

  const currentStyle = variantStyles[variant] || variantStyles.primary;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${baseStyle} ${className} ${disabled ? 'opacity-50 cursor-not-allowed grayscale' : ''}`}
      style={currentStyle}
    >
      {children}
    </button>
  );
};

export default Button;